export type ContactRegistrationInfoMessages = {
  registrationDateLabel: string;
  lastModifiedDateLabel: string;
  consentDateLabel: string;
  consentPendingLabel: string;
};

export const CONTACT_REGISTRATION_INFO_MESSAGES: ContactRegistrationInfoMessages = {
  registrationDateLabel: "Data de cadastro",
  lastModifiedDateLabel: "Data da última alteração",
  consentDateLabel: "Data do consentimento",
  consentPendingLabel: "Pendente",
};
